import PropTypes from "prop-types";

import StraightLineTool, {
  straightLinePropTypes,
  straightLineBaseDefaults,
} from "./StraightLineTool";
import EachTrendLine from "./wrapper/EachTrendLine";

// Config sobre StraightLineTool (auditoria 2026-07-17, item 1b).
// Wrapper compartilhado com TrendLine/Ray — sempre foi EachTrendLine.
class Line extends StraightLineTool {}

Line.collectionKey = "lines";
Line.EachComponent = EachTrendLine;
Line.evoId = "interactive-line";

Line.propTypes = {
  ...straightLinePropTypes,
  type: PropTypes.oneOf(["XLINE"]),
  lines: PropTypes.array.isRequired,
};

Line.defaultProps = {
  ...straightLineBaseDefaults,
  type: "XLINE",
  lines: [],
};

export default Line;
